import { Box, styled } from "@mui/material";

import { AssistantActionButton } from "../../styles";

export const AssistantFeatureActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  flexShrink: 0,
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(3, 5),
  borderTop: `1px solid ${theme.palette.custom.semantic.border.subtle}`,
  backgroundColor: theme.palette.custom.semantic.surface.card,
}));

export const StyledAssistantFeatureWalkthroughActionsAssistantActionButton =
  styled(AssistantActionButton)({ flexShrink: 0, whiteSpace: "nowrap" });
